"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const CustomerRoleStore_1 = __importDefault(require("./CustomerRoleStore"));
const DepartmentStore_1 = __importDefault(require("./DepartmentStore"));
class AccountStore {
    api = new ecommerce_1.AccountApi(configuration_1.default);
    initialized = false;
    submitting = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            initialized: mobx_1.observable,
            submitting: mobx_1.observable,
            isSubmitting: mobx_1.computed,
            setSubmitting: mobx_1.action.bound,
        });
    }
    get isSubmitting() {
        return this.submitting;
    }
    registerAccount(general, personal, company) {
        const department = DepartmentStore_1.default.departments.find((entry) => entry.value === personal.department);
        const role = CustomerRoleStore_1.default.roles.find((entry) => entry.value === personal.role);
        return this.api.registerAccount({
            accountRegister: {
                company: company,
                personal: {
                    ...personal,
                    department: department?.label,
                    role: role?.label,
                },
                companyExternalId: general.verifiedCompanyExternalId ?? general.checkedCompanyExternalId,
                countryCode: general.verifiedCountryCode ?? general.selectedCountryCode ?? '',
                customerId: general.checkCustomerId,
                newsletter: general.acceptedNewsletter,
                reseller: general.selectedReseller,
                serialNumber: general.checkSerialNumber,
                termsAndConditions: general.acceptedTermsAndConditions,
                verificationCode: general.verificationCode,
                zipCode: general.checkZipCode,
            },
        });
    }
    verifyVerificationCode(code) {
        return this.api.verifyVerificationCode({ accountVerificationCode: { code } }).then((result) => {
            if (!result.data?.defaultMassiveAddress?.country?.iso) {
                return Promise.reject();
            }
            return result.data;
        });
    }
    updateAccount(data) {
        if (this.isSubmitting ||
            !AuthorizationStore_1.default.user ||
            !AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.SHOP_READ)) {
            return Promise.reject();
        }
        this.setSubmitting(true);
        return this.api
            .updateAccount({
            updateAccountRequestBody: data,
        })
            .then((customer) => customer)
            .finally(() => {
            this.setSubmitting(false);
        });
    }
    setSubmitting(submitting) {
        this.submitting = submitting;
    }
}
__decorate([
    bind_decorator_1.default
], AccountStore.prototype, "registerAccount", null);
__decorate([
    bind_decorator_1.default
], AccountStore.prototype, "verifyVerificationCode", null);
__decorate([
    bind_decorator_1.default
], AccountStore.prototype, "updateAccount", null);
exports.default = new AccountStore();
